export default __webpack_public_path__ + "static/media/ecommerce.e495ef1a.png";